import type {
  GetRouterClientIdentityAccountResponse,
  ListRouterClientIdentityAccountsResponse,
  ResetRouterClientIdentitySessionResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

const BASE = '/v1/ops/router-client-identities';

export interface RouterClientIdentityFilters {
  readonly orgId?: string;
  readonly accountId?: string;
  readonly memberAccountId?: string;
  readonly search?: string;
  readonly limit?: number;
}

export async function listRouterClientIdentityAccounts(
  filters: RouterClientIdentityFilters,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<ListRouterClientIdentityAccountsResponse> {
  const qs = new URLSearchParams();
  appendFilter(qs, 'orgId', filters.orgId);
  appendFilter(qs, 'accountId', filters.accountId);
  appendFilter(qs, 'memberAccountId', filters.memberAccountId);
  appendFilter(qs, 'search', filters.search);
  if (filters.limit !== undefined) {
    qs.set('limit', String(filters.limit));
  }
  const suffix = qs.size > 0 ? `?${qs.toString()}` : '';
  return opsApiRequest<ListRouterClientIdentityAccountsResponse>(
    `${BASE}/accounts${suffix}`,
    { signal },
    fetchImpl,
  );
}

export async function getRouterClientIdentityAccount(
  id: string,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<GetRouterClientIdentityAccountResponse> {
  return opsApiRequest<GetRouterClientIdentityAccountResponse>(
    `${BASE}/accounts/${encodeURIComponent(id)}`,
    { signal },
    fetchImpl,
  );
}

export async function resetRouterClientIdentitySession(
  id: string,
  fetchImpl: typeof fetch,
): Promise<ResetRouterClientIdentitySessionResponse> {
  return opsApiRequest<ResetRouterClientIdentitySessionResponse>(
    `${BASE}/sessions/${encodeURIComponent(id)}/reset`,
    { method: 'POST' },
    fetchImpl,
  );
}

function appendFilter(qs: URLSearchParams, key: string, value: string | undefined): void {
  const trimmed = value?.trim();
  if (trimmed !== undefined && trimmed.length > 0) {
    qs.set(key, trimmed);
  }
}
